import { render, staticRenderFns } from "./yc-overage.vue?vue&type=template&id=2c7ccffe&scoped=true&"
import script from "./yc-overage.vue?vue&type=script&lang=js&"
export * from "./yc-overage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7ccffe",
  null
  
)

export default component.exports